import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { TabView, TabPanel } from "primereact/tabview";
import {
  deleteSalesCard,
  getSalesCardDetail,
  updateSalesCardStatus,
} from "../../../../services/crm/salesCardService";
import { Card } from "react-bootstrap";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SalesCardForm from "./salesCardForm";
import { formatDate } from "../../../../utils/utils";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import QuotationForm from "../../sales/quotation/quotationForm/quotationForm";
import {
  CustomOutlinedDisabledTextField,
  CustomOutlinedDisabledCurrencyField,
} from "../../../../partials/content/Forms";
import { Badge } from "react-bootstrap";
import Notes from "../../common/notes";
import Attachments from "../../common/attachments";
import VisitScheduleForm from "../journey/visitSchedule/VisitScheduleForm";
import VisitDetailContent from "../journey/journeyDetail/VisitDetailContent";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import Illustration from "../../../../partials/content/Illustration";
import QuotationBasicInfo from "../../sales/quotation/quotationDetail/quotationBasicInfo";
function SalesCardDetail({ salesCardID, onReloadSalesCards, onCloseDialog }) {
  const { reload } = useGlobalData();
  const [openVisitScheduleForm, setOpenVisitScheduleForm] = useState(false);
  const [openSalesCardForm, setOpenSalesCardForm] = useState(false);
  const [openVisitDetail, setOpenVisitDetail] = useState(false);
  const [openQuotationForm, setOpenQuotationForm] = useState(false);
  const [auth, setAuth] = useState({});
  const [visit, setVisit] = useState({
    ID: 0,
  });
  const [salesCard, setSalesCard] = useState({
    customer: { ID: 0, customerName: "" },
    lead: { ID: 0, leadName: "", contactName: "" },
    quotation: { ID: 0, grandTotal: 0 },
    currency: { ID: 0, currencyCode: "" },
    visits: [],
  });

  useEffect(() => {
    getSalesCardData(salesCardID);
  }, [salesCardID, reload]);

  const salesCardVisitDetailColumn = [
    {
      header: "Description",
      field: "description",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      <div className="tabview">
        <div className="card">
          <TabView className="tabview" scrollable>
            <TabPanel header="Sales Card" rightIcon="fas fa-address-card">
              <React.Fragment>
                {salesCard.ID > 0 ? (
                  <React.Fragment>
                    <Card>
                      <Card.Header>
                        <i className="fas fa-th-large"></i>
                        <span>
                          <strong>Sales Card Basic Info</strong>
                        </span>
                        {salesCard.archive ? (
                          <Badge className="float-right ml-1" variant="dark">
                            Archived
                          </Badge>
                        ) : null}
                      </Card.Header>
                      <Card.Body>
                        <div className="row">
                          <div className="col-sm-6 col-md-6 col-lg-6">
                            <CustomOutlinedDisabledTextField
                              label="Sales Card Name"
                              value={salesCard.title}
                            />
                            {salesCard.customer.ID > 0 ? (
                              <React.Fragment>
                                <CustomOutlinedDisabledTextField
                                  label="Customer Name"
                                  value={salesCard.customer.customerName}
                                />
                              </React.Fragment>
                            ) : salesCard.lead.ID > 0 ? (
                              <React.Fragment>
                                <CustomOutlinedDisabledTextField
                                  label="Lead Name"
                                  value={salesCard.lead.leadName}
                                />
                              </React.Fragment>
                            ) : null}
                            <CustomOutlinedDisabledTextField
                              label="Assigned To"
                              value={salesCard.assignedUserName}
                            />
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-6">
                            <CustomOutlinedDisabledTextField
                              label="Currency"
                              value={salesCard.currency.currencyCode}
                            />
                            <CustomOutlinedDisabledCurrencyField
                              label="Estimated Value"
                              value={salesCard.estimatedValue}
                            />
                            <CustomOutlinedDisabledTextField
                              label="Sales Life Cycle Status"
                              value={salesCard.slcStatus.statusName}
                            />
                          </div>
                        </div>
                        <CustomOutlinedDisabledTextField
                          label="Description"
                          value={salesCard.description}
                          multiline
                          minRows={5}
                        />
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                            {salesCard.statusID < 9998 ? (
                              <React.Fragment>
                                {auth.edit ? (
                                  <button
                                    className="btn btn-label-danger btn-md btn-pill btn-bold"
                                    onClick={() => {
                                      deleteSalesCardData();
                                    }}
                                  >
                                    <i className="fas fa-trash-alt"></i>
                                    Delete Sales Card
                                  </button>
                                ) : null}
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                {!salesCard.archive ? (
                                  <button
                                    className={`btn btn-label-dark btn-md btn-pill btn-bold`}
                                    onClick={() => {
                                      archiveSalesCard();
                                    }}
                                  >
                                    <i className="fas fa-archive"></i>
                                    Archive
                                  </button>
                                ) : null}
                              </React.Fragment>
                            )}
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </React.Fragment>
                ) : null}
              </React.Fragment>
            </TabPanel>
            <TabPanel header="Quotation" rightIcon="fas fa-file-contract">
              {salesCard.quotationID > 0 ? (
                <QuotationBasicInfo quotationID={salesCard.quotationID} />
              ) : (
                <React.Fragment>
                  <Illustration
                    imageSource="INVIFO Sales.png"
                    guidance="You don't have any Quotation for this sales card yet"
                    guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                    size="md"
                  ></Illustration>
                  <div className="text-center py-3">
                    <button
                      type="button"
                      className="btn btn-primary btn-md btn-pill btn-bold mx-1"
                      onClick={() => {
                        setOpenQuotationForm(true);
                      }}
                    >
                      <i className="fas fa-plus-circle"></i>
                      New Quotation
                    </button>
                  </div>
                </React.Fragment>
              )}
            </TabPanel>
            <TabPanel
              header="Visit Schedules"
              rightIcon="fas fa-calendar-check"
            >
              <React.Fragment>
                {salesCard.visits.length ? (
                  <React.Fragment>
                    <CustomDataTable
                      data={salesCard.visits}
                      dataDetailColumns={salesCardVisitDetailColumn}
                      onRefreshData={() => {
                        getSalesCardData(salesCardID);
                      }}
                      buttons={[
                        {
                          name: "New Visit Schedule",
                          onClick: () => {
                            setOpenVisitScheduleForm(true);
                          },
                          icon: "fas fa-plus-circle",
                          color: "primary",
                        },
                      ]}
                      columns={[
                        {
                          header: "Visit ID",
                          field: "ID",
                          body: null,
                          sortable: true,
                          filter: true,
                        },
                        {
                          header: "Visit Status",
                          field: "statusName",
                          body: (rowData) => {
                            if (rowData.statusID === 1) {
                              return (
                                <Badge variant="warning">
                                  {rowData.statusName}
                                </Badge>
                              );
                            } else if (rowData.statusID === 2) {
                              return (
                                <Badge variant="primary">
                                  {rowData.statusName}
                                </Badge>
                              );
                            } else if (rowData.statusID === 3) {
                              return (
                                <Badge variant="success">
                                  {rowData.statusName}
                                </Badge>
                              );
                            } else if (rowData.statusID === 9) {
                              return (
                                <Badge variant="danger">
                                  {rowData.statusName}
                                </Badge>
                              );
                            } else {
                              return (
                                <Badge variant="dark">
                                  {rowData.statusName}
                                </Badge>
                              );
                            }
                          },
                          sortable: true,
                          filter: true,
                        },
                        {
                          header: "Plan Visit Date",
                          field: "planVisitDate",
                          body: (rowData) => formatDate(rowData.planVisitDate),
                          sortable: true,
                          filter: true,
                        },
                        {
                          header: "Actual Visit Date",
                          field: "actVisitDate",
                          body: (rowData) =>
                            formatDate(rowData.actVisitDate, true, false),
                          sortable: true,
                          filter: true,
                        },
                        {
                          header: "Actions",
                          body: (rowData) => (
                            <React.Fragment>
                              <BootstrapTooltip title="Visit Detail">
                                <button
                                  type="button"
                                  onClick={() => {
                                    setVisit(rowData);
                                    setOpenVisitDetail(true);
                                  }}
                                  className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                                >
                                  <i className="fas fa-list-alt"></i>
                                </button>
                              </BootstrapTooltip>
                            </React.Fragment>
                          ),
                          sortable: false,
                        },
                      ]}
                    />
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Illustration
                      imageSource="INVIFO CRM.png"
                      guidance="You don't have any Visit Schedules for this sales card yet"
                      guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                      size="md"
                    ></Illustration>
                    <div className="text-center py-3">
                      <button
                        type="button"
                        className="btn btn-primary btn-md btn-pill btn-bold mx-1"
                        onClick={() => {
                          setOpenVisitScheduleForm(true);
                        }}
                      >
                        <i className="fas fa-plus-circle"></i>
                        New Visit Schedule
                      </button>
                    </div>
                  </React.Fragment>
                )}
              </React.Fragment>
            </TabPanel>
            <TabPanel header="Attachments" rightIcon="fas fa-paperclip">
              <Attachments docType="SLCL" docID={salesCard.ID} />
            </TabPanel>
            <TabPanel header="Notes" rightIcon="fas fa-sticky-note">
              <Notes docType="SLCL" docID={salesCard.ID} />
            </TabPanel>
          </TabView>
        </div>
      </div>
      <DialogLayout
        maxWIdth="xl"
        open={openQuotationForm}
        onCloseDialog={handleCloseQuotationForm}
      >
        <QuotationForm
          quotationIDImp={salesCard.quotationID}
          salesCardID={salesCard.ID}
          lead={salesCard.lead}
          customer={salesCard.customer}
          user={salesCard.assignedUser}
          headSubmitButton={false}
          onCloseDialog={handleCloseQuotationForm}
          onConfirmSave={() => {
            handleCloseQuotationForm();
            getSalesCardData(salesCard.ID);
            onReloadSalesCards();
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openVisitDetail}
        title="Visit Detail"
        onCloseDialog={handleCloseVisitDetail}
      >
        {visit.ID > 0 ? (
          <VisitDetailContent appCode="SLCL" visitID={visit.ID} />
        ) : null}
      </DialogLayout>
      <DialogLayout
        open={openSalesCardForm}
        title="Sales Card Form"
        maxWIdth="sm"
        onCloseDialog={handleCloseSalesCardForm}
      >
        <SalesCardForm
          salesCard={salesCard}
          onCloseDialog={handleCloseSalesCardForm}
          onConfirmSave={() => {
            handleCloseSalesCardForm();
            getSalesCardData();
            onReloadSalesCards();
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openVisitScheduleForm}
        title="Visit Schedule Form"
        maxWIdth="lg"
        onCloseDialog={() => {
          setOpenVisitScheduleForm(false);
        }}
      >
        <VisitScheduleForm
          salesCardID={salesCard.ID}
          customerID={salesCard.customer.ID}
          leadID={salesCard.lead.ID}
          onCloseDialog={() => {
            setOpenVisitScheduleForm(false);
          }}
          onConfirmSave={() => {
            getSalesCardData(salesCard.ID);
            setOpenVisitScheduleForm(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  function handleCloseQuotationForm() {
    setOpenQuotationForm(false);
  }

  function handleCloseVisitDetail() {
    setOpenVisitDetail(false);
  }

  function handleCloseSalesCardForm() {
    setOpenSalesCardForm(false);
  }

  function deleteSalesCardData() {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Sales Card ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteSalesCard(salesCardID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            this.getLeadsData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  function archiveSalesCard() {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to archive this Sales Card ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, archive it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          updateSalesCardStatus(salesCard, 0, true).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Archived",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getSalesCardData(salesCard.ID);
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  async function getSalesCardData(salesCardID) {
    const response = await getSalesCardDetail(salesCardID);
    const { data, auth } = response.data;
    setAuth(auth);
    setSalesCard(data.salesCard);
  }
}

export default SalesCardDetail;
